import NotificationDateSeparatorModule from './notification-date-separator.module'

export default NotificationDateSeparatorModule
